import { useEffect } from "react";
import { useGuestStore } from "./guest.store";

import { spErrorTags, spWarnTags } from "@eventr/common";
import i18n from "i18n/i18next";
import { routes } from "routing";
import AppLoadingSpinner from "../../assets/animated/appLoadingSpinner";
import { defaultAddSnack } from "../../state/overlayState/overlayContext";
import { logEvent } from "../firebase/firebase";
import { clearPendingGuestLink } from "./pendingGuestLink";
import { useRouteQueryParams } from "routing/query-params";

export const GuestResolverPage = () => {
  const queryParams = useRouteQueryParams();

  useEffect(() => {
    const resolve = async (encoded: string) => {
      try {
        await useGuestStore.getState().resolveGuestData(encoded);
        // Cleared before replacing, so the native root already wants the tabs. Off iOS the
        // clear is a no-op and the replace is what navigates.
        clearPendingGuestLink();
        window.replacePath(routes.home.path);
      } catch (error) {
        logEvent("guest_resolve_failed", { code: encoded });
        defaultAddSnack(i18n.t("guest.itineraryNotFound"), "error");
        spErrorTags(`Guest resolve failed: ${error}`, ["GuestResolver"]);
        // Signed out there are no tabs and "/" is already the root.
        clearPendingGuestLink();
        window.replacePath("/");
      }
    };
    const encoded: string = queryParams.data ?? "";
    if (encoded) {
      resolve(encoded);
    } else {
      spWarnTags("Guest resolver reached with no data parameter", ["GuestResolver"]);
    }
  }, [queryParams.data]);

  return <AppLoadingSpinner />;
};
